import React, { useContext, useEffect, useState } from "react";
import { MyContext } from "../../globalContext";
import { fetchContentFromAzureBlobStorage } from '../../data/Contentapi';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PropTypes from "prop-types";
import {CircularProgress } from '@mui/material';


const TexasHospitalBased = ({searchResultsProp}) => {

   
    const [showDownloadProgress, setShowDownloadProgress] = useState(false);
    const { t } = useTranslation();
    const { languageData } = useContext(MyContext);
    const [providerTypeCode, setProviderTypeCode] = useState([]);
    const [resultState, setResultState]= useState([]);
    
  

    useEffect(() => {
     setProviderTypeCode(searchResultsProp && searchResultsProp[0]?.provider?.providerTypeCode);
     setResultState(searchResultsProp && searchResultsProp[0]?.provider?.officeList?.office[0]?.address?.domesticAddress?.state?.stateAbbreviation);
    
    },[]);

    const getTexasHospitalBasedPdf = async (event) => {
        try {
            event.preventDefault();
      setShowDownloadProgress(true);
     

          
            const response = await fetchContentFromAzureBlobStorage(
                languageData.toLowerCase(),
                "Disclaimers",
                "TX_HOSP_BASED.pdf"
            );
            console.log('Response got');

            const url = window.URL.createObjectURL(convertToBlob(response));
            const a = document.createElement('a');
            a.href = url;
            a.download = 'TX_HOSP_BASED.pdf';
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            setShowDownloadProgress(false);

        } catch (error) {
            setShowDownloadProgress(false);
            console.error('Error downloading the PDF:', error);
        }




    };
    const convertToBlob = (response) => {
        if (response) {

            const imageString = response.imageString; 
            const byteCharacters = atob(imageString); 
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' }); 
            return blob;
        }

    }


    return (
        <Box sx={{ width: "99%" }} >   
    
      {providerTypeCode && providerTypeCode == "ACUTE" && resultState && resultState == "TX" &&    
            <div className="alignLink">
                <span><a href="#" onClick={getTexasHospitalBasedPdf} className="results-link Cp"><b> {t(`Here`)} </b></a> {t(`HereContent`)} {showDownloadProgress && <CircularProgress data-testid='loading-circle' color="primary" style={{ verticalAlign: "middle", width: '20px', height: '20px', marginLeft:"5px" }}  />}</span>
            </div>
      } 


  

        </Box>
    )
};

TexasHospitalBased.propTypes = {    
    searchResultsProp: PropTypes.any
  
  };

export default TexasHospitalBased;